var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1556_7600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7586 22.0859V40.5625C38.7586 42.4961 37.5469 44 36 44H32.2273C30.6805 44 29.4688 42.4875 29.4688 40.5625V22.0859C29.4688 20.1523 30.6805 18.6484 32.2273 18.6484H36C37.5383 18.6484 38.7586 20.1609 38.7586 22.0859Z",
    fill: "#EB2019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8188 11.2496C38.561 11.4301 38.2259 11.4387 37.9509 11.2754L35.3727 9.72855C31.1274 16.7582 25.1376 23.3754 13.5704 23.3754C11.1298 23.3754 8.43993 23.0832 5.46649 22.4301C5.03681 22.3356 4.76181 21.9145 4.84774 21.4762C4.93368 21.0809 5.29462 20.8145 5.69853 20.8489C6.4204 20.909 23.1954 22.0348 30.2423 6.52308L27.604 5.24262C27.2087 5.05355 27.0368 4.5723 27.2259 4.17699C27.3118 3.99652 27.4579 3.85902 27.6384 3.78168L36.3954 0.0605842C36.7993 -0.111291 37.272 0.0777717 37.4438 0.481678C37.4696 0.541834 37.4868 0.60199 37.4954 0.662147L39.154 10.4504C39.2142 10.7598 39.0767 11.0778 38.8188 11.2496Z",
    fill: "#EB2019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.65 28.875V40.5625C26.65 42.4961 25.4383 44 23.8914 44H20.1102C18.5633 44 17.3516 42.4875 17.3516 40.5625V28.875C17.3516 26.9414 18.5633 25.4375 20.1102 25.4375H23.8828C25.4383 25.4289 26.65 26.9414 26.65 28.875Z",
    fill: "#EB2019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8082 34.5303V40.5631C14.8082 42.4881 13.5965 44.0006 12.0496 44.0006H8.26836C6.72148 44.0006 5.50977 42.4881 5.50977 40.5631V34.5303C5.50977 32.5967 6.72148 31.0928 8.26836 31.0928H12.041C13.5965 31.0842 14.8082 32.5967 14.8082 34.5303Z",
    fill: "#EB2019"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1556_7600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChart);
export default __webpack_public_path__ + "static/media/icon-chart.aa49cfd59baf1c4ca67d10b3634dc4c8.svg";
export { ForwardRef as ReactComponent };